import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jaxvn3rd8j: FaireBrandEntity = {
  token: "b_jaxvn3rd8j",
  type: "brand",
  name: "Táche Pistachio Milk",
  avatarUrl:
    "https://cdn.faire.com/fastly/c5bb70e8fd7f1d712fb7e577798a71d6769124ed85303e5d335c0e0d993e3823.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e6d4c180926acdcda61bb29f6dad4ef272f3bc5bfca1b9de06151ee28911cdfc.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c5bb70e8fd7f1d712fb7e577798a71d6769124ed85303e5d335c0e0d993e3823.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e6d4c180926acdcda61bb29f6dad4ef272f3bc5bfca1b9de06151ee28911cdfc.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 50,
  isInsider: true,
  description:
    "Táche is made using a fraction of the water needed for almond milk and–unlike oat milk–absolutely no added oils. It's better for you and the environment. There are lots of milks, but there is only one Táche.\n\nBased and Designed in Brooklyn, NY.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:42.766Z",
    importedBy: "entity-db-cli",
  },
};
